<template>
  <div id="content" class="crpg-o-upgrade-plan-content category">
    <div id="category_top" class="crpg-o-upgrade-plan-content__category">
      <div class="top_image">
        <h2>
          {{ $t("upgradePlan.title") }}
          <br />
          <span class="j"> {{ $t("upgradePlan.subTitle") }} </span>
        </h2>
        <img :src="golfTop" class="upgrade_plan_img" />
      </div>
    </div>
    <div id="menus">
      <ul>
        <li
          class="menu"
          v-for="item in content.tripPlanDate"
          :key="item.image"
        >
          <MoleculesUpgradePlanTripPlan
            :image="item.image"
            :name="item.name"
            :date="item.date"
            :catchTxt="item.catchTxt"
          />
        </li>
      </ul>
    </div>
    <!--/menus-->
  </div>
</template>

<script>
import text from "@/assets/txt/upgrade_plan.json";
import MoleculesUpgradePlanTripPlan from "@/components/molecules/upgradePlan/TripPlan.vue";

var obj = text;

export default {
  name: "UpgradePlanContent",
  components: {
    MoleculesUpgradePlanTripPlan,
  },
  data() {
    return {
      content: obj,
      golfTop: require("@/assets/img/upgrade_plan_top.jpg"),
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/organisms/upgradePlan/upgradePlanContent.scss";
</style>
